// Layout tokens shared by the three price-database pages (Ink, Generic,
// Curated) so they read as one family. Kept out of the .tsx so Fast Refresh works.

/** A column that shrinks to its content (numbers, dates, chips, actions); free width goes to text columns. */
export const TIGHT_COL_SX = { width: "1%", whiteSpace: "nowrap" } as const;

/** Edit/add dialog body: two columns from 600px up, one below. */
export const FORM_GRID_SX = {
  display: "grid",
  gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
  gap: 2,
  pt: 1,
} as const;

/** A dialog field that spans both columns (long text, keywords, notes). */
export const FULL_SPAN_SX = { gridColumn: "1 / -1" } as const;

/** Money as shown in the tables: thousands separator, two decimals. */
export function formatMoney(value: number | string | null | undefined): string {
  const n = typeof value === "string" ? parseFloat(value) : value;
  if (n === null || n === undefined || Number.isNaN(n)) return "-";
  return `$${n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}
